module.exports = __webpack_public_path__ + "static/assets/5b412bcf31537299f5005ae7d3153c3c.png";